import { ITabItem } from 'components/tab';
import React, { useMemo } from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import RMSvgIcon from '../CommonComponents/RMSvgIcon';

export interface Props {
  defaultActiveKey: string;
  activeKey?: string;
  id?: string;
  tabItems: ITabItem[];
  className?: string;
  onSelect?: any;
}

const RMTabs = (props: Props) => {
  const {
    defaultActiveKey,
    activeKey,
    id,
    tabItems,
    className = 'mb-3',
    onSelect,
  } = props;

  const tabs = useMemo(() => {
    return tabItems.map((val) => {
      return (
        <Tab
          id={`controls-rmtabs-tab-${val.title}`}
          data-testid={`controls-rmtabs-tab-${val.title}`}
          tabClassName={val.tabClassName}
          eventKey={val.eventKey}
          disabled={val.disabled}
          title={
            <>
              {val.iconProps && <RMSvgIcon {...val.iconProps} />}
              {val.title}
            </>
          }
          key={val.eventKey}
          style={{ border: 'none', ...(val.height ? { height: val.height } : {}) }}
        >
          {val.content}
        </Tab>
      );
    });
  }, [tabItems]);

  const onSelectEvent = (key, e) => {
    if (e) {
      e.currentTarget.blur();
    }
    if (onSelect) {
      onSelect(key);
    }
  };

  return (
    <Tabs
      defaultActiveKey={defaultActiveKey}
      activeKey={activeKey}
      transition={false}
      id={`controls-rmtabs-${id}`}
      data-testid={`controls-rmtabs-${id}`}
      className={className + ' ' + 'customTab'}
      justify
      onSelect={onSelectEvent}
    >
      {tabs}
    </Tabs>
  );
};

export default RMTabs;
